// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","455":"689ef7e7","977":"de57366e"}[chunkId] + ".chunk.js";
};